import { useState, useEffect } from 'react';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import { Box } from '@mui/material';
import transformLogoUrl from '../../../utils/transformLogoUrl';

const EcommerceLogo = ({
  src,
  alt = 'ecommerce-logo',
  className,
  sx,
  fallbackClassName = 'order-card__logo-placeholder',
  fallbackSx = { fontSize: '3rem' },
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  if (!src || hasError) {
    return <EmojiEmotionsIcon className={fallbackClassName} sx={fallbackSx} />;
  }

  return (
    <Box
      component="img"
      src={transformLogoUrl(src)}
      alt={alt}
      className={className}
      sx={sx}
      onError={() => setHasError(true)}
    />
  );
};

export default EcommerceLogo;
